var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackdollor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40879 4.35972C1.40879 5.23493 1.98826 6.0743 3.01971 6.69317C4.05116 7.31204 5.4501 7.65972 6.90879 7.65972C8.36748 7.65972 9.76643 7.31204 10.7979 6.69317C11.8293 6.0743 12.4088 5.23493 12.4088 4.35972C12.4088 3.4845 11.8293 2.64513 10.7979 2.02626C9.76643 1.40739 8.36748 1.05972 6.90879 1.05972C5.4501 1.05972 4.05116 1.40739 3.01971 2.02626C1.98826 2.64513 1.40879 3.4845 1.40879 4.35972Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40879 4.35972V8.75972C1.40879 10.5824 3.87169 12.0597 6.90879 12.0597C9.94589 12.0597 12.4088 10.5824 12.4088 8.75972V4.35972",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40879 8.75972V13.1597C1.40879 14.9824 3.87169 16.4597 6.90879 16.4597C9.94589 16.4597 12.4088 14.9824 12.4088 13.1597V8.75972",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40879 13.1597V17.5597C1.40879 19.3824 3.87169 20.8597 6.90879 20.8597C9.94589 20.8597 12.4088 19.3824 12.4088 17.5597V13.1597",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackdollor);
export default __webpack_public_path__ + "static/media/blackdollor.e394c32610eeaa3e49237ba0d09ad3e9.svg";
export { ForwardRef as ReactComponent };